<template lang="pug">
  div(class="comparing-table-header")
    div(v-if="!xsDevice")
    div(
      v-for="plan in plans"
      :key="plan.id"
      class="comparing-table-header__plan"
    )
      div(:class="[xsDevice ? 'mb-2' : 'mb-6']")
        div(class="d-flex align-center justify-space-between")
          billing-premium-label(v-if="plan.id === premiumPlanId")
          div(
            v-else
            class="dark"
            :class="[xsDevice ? 'text-12px' : 'text-16px']"
          ) {{ _.upperFirst(plan.name) }}
          div(
            v-if="plan.id === currentPlan?.tariff.id"
            class="billing-plans__selected-label text-12px"
          ) {{ $t('Selected plan') }}
        div(
          v-if="!xsDevice"
          class="text-14px fw-500 dark pt-2"
        ) {{ plan.subscriptionPrice / 100 }}
          |
          |
          span(class="text-14px fw-300") {{ $t('₴/month') }}
      v-btn(
        v-if="(plan.id === premiumPlanId || (plan.id === freePlanId && currentPlan?.tariff.id === freePlanId)) && !xsDevice"
        class="w-100"
        :class="{ 'main-button sm': plan.id === premiumPlanId }"
        small
        :disabled="checkDisabledButton(plan.id)"
        :loading="plan.id === premiumPlanId ? updateToPremiumLoading : false"
        @click="updateToPremium(false)"
      ) {{ setButtonText(plan.id) }}
    div(class="comparing-table-header__plan")
      div(class="mb-6")
        div(class="d-flex align-center justify-space-between")
          div(
            class="dark"
            :class="[xsDevice ? 'text-12px' : 'text-16px']"
          ) Premium+
        div(
          v-if="!xsDevice"
          class="text-14px fw-300 pt-2"
        ) {{ $t('Individually') }}
      v-btn(
        v-if="!xsDevice"
        outlined
        small
        @click="$emit('planDemo')"
      ) {{ $t('Plan demo') }}
</template>

<script>
import { mapGetters } from 'vuex'
import BillingPremiumLabel from '~/modules/billing/components/billing-premium-label'
import actions from '~/modules/billing/mixins/actions'
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'BillingPlansComparingTableHeader',
  components: { BillingPremiumLabel },
  mixins: [actions, responsive],
  props: {
    plans: {
      type: Array,
      default: () => []
    },
    premiumPlanId: {
      type: String,
      default: null
    },
    freePlanId: {
      type: String,
      default: null
    },
    checkDisabledButton: {
      type: Function,
      default: () => {}
    },
    setButtonText: {
      type: Function,
      default: () => {}
    },
    showSelectPlanButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('billing', {
      currentPlan: 'currentPlan'
    })
  }
}
</script>

<style scoped lang="scss">
.comparing-table-header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  border-bottom: 1px solid #e3e3e3;

  @media (min-width: map-get($breakpoints, 'sm')) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  &__plan {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    padding: 6px;

    @media (min-width: map-get($breakpoints, 'sm')) {
      padding: 24px;
    }
  }
}
</style>
